
import React from 'react';
import { ArrowRight, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const BusinessInfoBox: React.FC = () => {
  return (
    <div className="mt-12 bg-white p-6 rounded-lg border border-joerg-200 max-w-3xl mx-auto shadow-md">
      <h3 className="text-xl font-semibold mb-4 text-center">Maßgeschneiderte Business-Lösungen</h3>
      <p className="text-joerg-600 mb-6 text-left">
        Jedes Unternehmen hat einzigartige Herausforderungen. Ich entwickle individuelle Konzepte, 
        die genau auf Ihre spezifischen Anforderungen zugeschnitten sind.
      </p>
      
      <div className="px-4 py-4 bg-joerg-50 rounded-lg mb-6 text-center">
        <p className="text-joerg-700 text-left font-medium">
          Die genannten Preise dienen zur Orientierung. Für ein verbindliches Angebot kontaktieren Sie mich gerne direkt.
        </p>
      </div>
      
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <Link
          to="/consulting#katalysator-fuehrung"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-joerg-200 text-joerg-700 hover:bg-joerg-50 transition-colors"
        >
          Mehr über Katalysator-Führung <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
        
        <a
          href="https://zeeg.me/joerghoermann"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary text-white hover:bg-primary-dark transition-colors"
          onClick={() => {}}
        >
          Erstgespräch vereinbaren <ExternalLink className="ml-2 h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default BusinessInfoBox;
